/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
    /* 01.General */
    'general.copyright': 'Myma.ai © 2019 สงวนลิขสิทธิ์',

    /* 02.User Login, Logout, Register */
    'user.login-title': 'เข้าสู่ระบบ',
    'user.register': 'ลงทะเบียน',
    'user.forgot-password': 'ลืมรหัสผ่าน',
    'user.email': 'อีเมล',
    'user.newpassword': 'รหัสผ่านใหม่',
    'user.currentpassword': 'รหัสผ่านปัจจุบัน',
    'user.newpasswordagain': 'รหัสผ่านใหม่อีกครั้ง',
    'user.password': 'รหัสผ่าน',
    'user.forgot-password-question': 'ลืมรหัสผ่าน?',
    'user.fullname': 'ชื่อเต็ม',
    'user.firstname': 'First Name',
    'user.lastname': 'Last Name',
    'user.login-button': 'LOGIN',
    'user.register-button': 'REGISTER',
    'user.reset-password-button': 'RESET',
    'user.buy': 'BUY',
    'user.username': 'Username',

    /* 03.Menu */
    'menu.app': 'Home',


    'menu.default': 'Default',
    'menu.analytics': 'Analytics',
    'menu.ecommerce': 'Ecommerce',
    'menu.content': 'Content',
    'menu.pages': 'Pages',
    'menu.data-list': 'Data List',
    'menu.thumb-list': 'Thumb List',
    'menu.image-list': 'Image List',
    'menu.details': 'Details',
    'menu.search': 'Search',
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.forgot-password': 'Forgot Password',
    'menu.error': 'Error',
    'menu.applications': 'Applications',
    'menu.todo': 'To-do List',
    'menu.survey': 'Survey',
    'menu.chat': 'Chat',
    'menu.ui': 'UI',
    'menu.edit': 'Edit',
    'menu.alerts': 'Alerts',
    'menu.badges': 'Badges',
    'menu.buttons': 'Buttons',
    'menu.cards': 'Cards',
    'menu.carousel': 'Carousel',
    'menu.charts': 'Charts',
    'menu.collapse': 'Collapse',
    'menu.dropdowns': 'Dropdowns',
    'menu.editors': 'Editors',
    'menu.form-layouts': 'Form Layouts',
    'menu.form-components': 'Form Components',
    'menu.form-validations': 'Form Validations',
    'menu.icons': 'Icons',
    'menu.input-groups': 'Input Groups',
    'menu.jumbotron': 'Jumbotron',
    'menu.modal': 'Modal',
    'menu.navigation': 'Navigation',
    'menu.popover-tooltip': 'Popover & Tooltip',
    'menu.sortable': 'Sortable',
    'menu.tables': 'Tables',
    'menu.menu': 'Menu',
    'menu.subhidden': 'Subhidden',
    'menu.hidden': 'Hidden',
    'menu.visible': 'Visible',
    'menu.maps': 'Maps',
    'menu.landingpage': 'Landing Page',
    'menu.multipage-home': 'Multipage Home',
    'menu.singlepage-home': 'Singlepage Home',
    'menu.about': 'About',
    'menu.auth-login': 'Auth Login',
    'menu.auth-register': 'Auth Register',
    'menu.blog': 'Blog',
    'menu.blog-detail': 'Blog Detail',
    'menu.careers': 'Careers',
    'menu.confirmation': 'Confirmation',
    'menu.contact': 'Contact',
    'menu.docs': 'Docs',
    'menu.features': 'Features',
    'menu.prices': 'Prices',
    'menu.videos': 'Videos',
    'menu.mailing': 'Mailing',
    'menu.invoice': 'Invoice',
    'menu.blank-page': 'Coming soon...',
    'menu.types': 'Menu Types',
    'menu.levels': 'Menu Levels',
    'menu.third-level-1': 'Third Level 1',
    'menu.third-level-2': 'Third Level 2',
    'menu.third-level-3': 'Third Level 3',

    /* 04.Dashboards */
    'dashboards.pending-orders': 'Pending Orders',
    'dashboards.completed-orders': 'Completed Orders',
    'dashboards.refund-requests': 'Refund Requests',
    'dashboards.new-comments': 'New Comments',
    'dashboards.sales': 'Sales',
    'dashboards.orders': 'Orders',
    'dashboards.refunds': 'Refunds',
    'dashboards.recent-orders': 'Recent Orders',
    'dashboards.product-categories': 'Product Categories',
    'dashboards.cakes': 'Cakes',
    'dashboards.tickets': 'Tickets',
    'dashboards.calendar': 'Calendar',
    'dashboards.best-sellers': 'Best Sellers',
    'dashboards.per-session': 'Per Session',
    'dashboards.profile-status': 'Profile Status',
    'dashboards.payment-status': 'Payment Status',
    'dashboards.work-progress': 'Work Progress',
    'dashboards.tasks-completed': 'Tasks Completed',
    'dashboards.payments-done': 'Payments Done',
    'dashboards.order-stock': 'Order - Stock',
    'dashboards.categories': 'Categories',
    'dashboards.quick-post': 'Quick Post',
    'dashboards.title': 'Title',
    'dashboards.content': 'Content',
    'dashboards.category': 'Category',
    'dashboards.save-and-publish': 'Save and Publish',
    'dashboards.top-viewed-posts': 'Top Viewed Posts',
    'dashboards.posts': 'Posts',
    'dashboards.pending-for-publish': 'Pending for publish',
    'dashboards.users': 'Users',
    'dashboards.on-approval-process': 'On approval process',
    'dashboards.alerts': 'Alerts',
    'dashboards.waiting-for-notice': 'Waiting for notice',
    'dashboards.files': 'Files',
    'dashboards.pending-for-print': 'Pending for print',
    'dashboards.logs': 'Logs',
    'dashboards.gogo': 'GOGO',
    'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
    'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
    'dashboards.advanced-search': 'Advanced Search',
    'dashboards.toppings': 'Toppings',
    'dashboards.type': 'Type',
    'dashboards.keyword': 'Keyword',
    'dashboards.search': 'Search',
    'dashboards.top-rated-items': 'Top Rated Items',
    'dashboards.topic': 'Topic',
    /* 05.Pages */
    'pages.title.dashboards.analytics': 'Analytics',
    'pages.title.ari': 'Availability and Rates',
    'pages.title.conversations': 'Conversations',
    'pages.title.bookings': 'Reservations and Bookings',
    'pages.title.tickets': 'Leads and Tickets',
    'pages.title.propinfo': 'Responses',
    'pages.title.discounts': 'Discounts and Promotions',
    'pages.title.finance': 'Finance',
    'pages.title.integration': 'Integration',
    'pages.title.admin': 'Admin',
    'pages.add-new': 'ADD NEW',
    'pages.add-new-modal-title': 'Add New Item',
    'pages.display-options': 'Display Options',
    'pages.orderby': 'Order By : ',
    'pages.product-name': 'Product Name',
    'pages.category': 'Category',
    'pages.description': 'Description',
    'pages.status': 'Status',
    'pages.cancel': 'Cancel',
    'pages.submit': 'Submit',
    'pages.delete': 'Delete',
    'pages.another-action': 'Another action',
    'pages.actions': 'ACTIONS',
    'pages.header': 'Header',
    'pages.details': 'DETAILS',
    'pages.orders': 'ORDERS',
    'pages.rating': 'Rating',
    'pages.price': 'Price',
    'pages.ingredients': 'Ingredients',
    'pages.is-vegan': 'Is Vegan',
    'pages.order-status': 'Order Status',
    'pages.bake-progress': 'Bake Progress',
    'pages.popularity': 'Popularity',
    'pages.comments': 'Comments',
    'pages.error-title': 'Ooops... looks like an error occurred!',
    'pages.error-code': 'Error code',
    'pages.go-back-home': 'GO BACK HOME',
    'pages.mailing-info':
        'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
    'pages.invoice-info':
        'Invoice template has an inline styled version for usage outside of the project as well as React version.',
    'pages.react-version': 'React Version',
    'pages.inline-version': 'Inline Styled Html Version',

    /* 06.Applications */

    /* 06.01.Chat */
    'chat.messages': 'Messages',
    'chat.contacts': 'Contacts',
    'chat.saysomething': 'Say something..',

    /* 06.02.Survey */
    'survey.delete': 'Delete',
    'survey.edit': 'Edit',
    'survey.add-new': 'ADD NEW',
    'survey.add-new-title': 'Add New Survey',
    'survey.title': 'Title',
    'survey.category': 'Category',
    'survey.label': 'Label',
    'survey.status': 'Status',
    'survey.cancel': 'Cancel',
    'survey.submit': 'Submit',
    'survey.another-action': 'Another action',
    'survey.display-options': 'Display Options',
    'survey.orderby': 'Order By : ',
    'survey.all-surveys': 'All Surveys',
    'survey.completed-surveys': 'Completed Surveys',
    'survey.categories': 'Categories',
    'survey.active-surveys': 'Active Surveys',
    'survey.labels': 'Labels',

    /* 06.03.Todo */
    'todo.add-new': 'ADD NEW',
    'todo.add-new-title': 'Add New Todo',
    'todo.title': 'Title',
    'todo.detail': 'Detail',
    'todo.category': 'Category',
    'todo.label': 'Label',
    'todo.status': 'Status',
    'todo.cancel': 'Cancel',
    'todo.submit': 'Submit',
    'todo.action': 'Action',
    'todo.another-action': 'Another action',
    'todo.display-options': 'Display Options',
    'todo.orderby': 'Order By : ',
    'todo.all-tasks': 'All Tasks',
    'todo.pending-tasks': 'Pending Tasks',
    'todo.completed-tasks': 'Completed Tasks',
    'todo.categories': 'Categories',
    'todo.labels': 'Labels',

    /* 07.UI */

    /* 07.01.Alerts */
    'alert.rounded': 'Rounded Alert',
    'alert.react-notifications': 'React Notifications',
    'alert.outline': 'Outline',
    'alert.primary': 'Primary',
    'alert.secondary': 'Secondary',
    'alert.info': 'Info',
    'alert.success': 'Success',
    'alert.warning': 'Warning',
    'alert.error': 'Error',
    'alert.filled': 'Filled',
    'alert.primary-text': 'This is a primary alert—check it out!',
    'alert.secondary-text': 'This is a secondary alert—check it out!',
    'alert.success-text': 'This is a success alert—check it out!',
    'alert.danger-text': 'This is a danger alert—check it out!',
    'alert.warning-text': 'This is a warning alert—check it out!',
    'alert.info-text': 'This is a info alert—check it out!',
    'alert.light-text': 'This is a light alert—check it out!',
    'alert.dark-text': 'This is a dark alert—check it out!',
    'alert.default': 'Default Alert',
    'alert.dismissing': 'Dismissing Alert',
    'alert.dismissing-text':
        'Holy guacamole! You should check in on some of those fields below.',
    'alert.dismissing-without-animate-text':
        'I am an alert and I can be dismissed without animating!',

    /* 07.02.Badges */
    'badge.sizes': 'Sizes',
    'badge.colors': 'Colors',
    'badge.outline': 'Outline',
    'badge.links': 'Links',
    'badge.counter-badges': 'Counter Badges',
    'badge.bootstrap-default': 'Bootstrap Default',
    'badge.primary': 'Primary',
    'badge.secondary': 'Secondary',
    'badge.success': 'Success',
    'badge.danger': 'Danger',
    'badge.warning': 'Warning',
    'badge.info': 'Info',
    'badge.light': 'Light',
    'badge.dark': 'Dark',

    /* 07.03.Buttons */
    'button.default': 'Bootstrap Default',
    'button.colors': 'Colors',
    'button.rounded': 'Rounded',
    'button.outline': 'Outline',
    'button.states': 'States',
    'button.sizes': 'Sizes',
    'button.button-groups': 'Button Groups',
    'button.large-button': 'Large Button',
    'button.small-button': 'Small Button',
    'button.extra-small-button': 'Extra Small Button',
    'button.block-button': 'Block Button',
    'button.active': 'Active',
    'button.disabled': 'Disabled',
    'button.basic': 'Basic',
    'button.toolbar': 'Toolbar',
    'button.nesting': 'Nesting',
    'button.vertical-variation': 'Vertical Variation',
    'button.checkbox-radio-button': 'Checkbox and Radio Button',
    'button.checkbox': 'Checkbox',
    'button.radio': 'Radio',
    'button.radio-button': 'Radio Button',
    'button.primary': 'Primary',
    'button.secondary': 'Secondary',
    'button.success': 'Success',
    'button.danger': 'Danger',
    'button.warning': 'Warning',
    'button.info': 'Info',
    'button.light': 'Light',
    'button.dark': 'Dark',
    'button.states-text':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.click-here': 'Click Here',
    'button.states-text-alternate':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.primary-link': 'Primary Link',
    'button.link': 'Link',
    'button.primary-button': 'Primary Button',
    'button.button': 'Button',
    'button.left': 'Left',
    'button.middle': 'Middle',
    'button.right': 'Right',
    'button.dropdown': 'Dropdown',
    'button.dropdown-link': 'Dropdown Link',

    /* 07.04.Cards */
    'cards.icon-card': 'Icon Card',
    'cards.image-card': 'Image Card',
    'cards.image-overlay-card': 'Image Overlay Card',
    'cards.image-card-list': 'Image Card List',
    'cards.tab-card': 'Tab Card',
    'cards.user-card': 'User Card',

    /* 07.05.Carousel */
    'carousel.basic': 'Carousel Basic',
    'carousel.single': 'Carousel Single',
    'carousel.without-controls': 'Carousel Without Controls',

    /* 07.06.Charts */
    'charts.line': 'Line Chart',
    'charts.polar': 'Polar Chart',
    'charts.area': 'Area Chart',
    'charts.scatter': 'Scatter Chart',
    'charts.bar': 'Bar Chart',
    'charts.radar': 'Radar Chart',
    'charts.pie': 'Pie Chart',
    'charts.doughnut': 'Doughnut Chart',
    'charts.shadow': 'Shadow',
    'charts.no-shadow': 'No Shadow',

    /* 07.07.Collapse */
    'collapse.basic': 'Basic',
    'collapse.toggle': 'Toggle',
    'collapse.accordion': 'Accordion',
    'collapse.controlled': 'Controlled',
    'collapse.uncontrolled': 'Uncontrolled',

    /* 07.08.Dropdowns */
    'dropdowns.basic': 'Basic',
    'dropdowns.controlled': 'Controlled',
    'dropdowns.uncontrolled': 'Uncontrolled',
    'dropdowns.dropdown': 'Dropdown',
    'dropdowns.header': 'Header',
    'dropdowns.action': 'Action',
    'dropdowns.another-action': 'Another Action',
    'dropdowns.right': 'Right',
    'dropdowns.left': 'Left',
    'dropdowns.drop-directions': 'Drop Directions',
    'dropdowns.dropright': 'Dropright',
    'dropdowns.dropleft': 'Dropleft',
    'dropdowns.small-button': 'Small Button',
    'dropdowns.large-button': 'Large Button',
    'dropdowns.sizing': 'Sizing',
    'dropdowns.split-button': 'Split Button Dropdowns',
    'dropdowns.dropup': 'Dropup',

    /* 07.09.Editors */
    'editors.draftjs': 'Draft.js',
    'editors.quill-standart': 'Quill Standard',
    'editors.quill-bubble': 'Quill Bubble',

    /* 07.10.Forms */
    'forms.basic': 'Basic',
    'forms.email': 'E-mail',
    'forms.email-muted': "We'll never share your email with anyone else.",
    'forms.password': 'Password',
    'forms.submit': 'Submit',
    'forms.horizontal': 'Horizontal',
    'forms.radios': 'Radios',
    'forms.first-radio': 'First radio',
    'forms.second-radio': 'Second radio',
    'forms.third-radio-disabled': 'Third disabled radio',
    'forms.checkbox': 'Checkbox',
    'forms.signin': 'Sign in',
    'forms.top-labels-over-line': 'Top Labels Over Line',
    'forms.tags': 'Tags',
    'forms.date': 'Date',
    'forms.state': 'State',
    'forms.top-labels-in-input': 'Top Labels In Input',
    'forms.email-u': 'E-MAIL',
    'forms.password-u': 'PASSWORD',
    'forms.tags-u': 'TAGS',
    'forms.date-u': 'DATE',
    'forms.state-u': 'STATE',
    'forms.grid': 'Form Grid',
    'forms.address': 'Address',
    'forms.address2': 'Address 2',
    'forms.city': 'City',
    'forms.city-message': 'Please select a city!',
    'forms.state-message': 'Please select a state!',
    'forms.zip': 'Zip',
    'forms.signup': 'Signup',
    'forms.inline': 'Inline',
    'forms.validation-availity': 'Availity Reactstrap Validation',
    'forms.validation-formik': 'Formik Validation',
    'forms.default': 'Default',
    'forms.firstname': 'First name',
    'forms.firstname-message': 'Please enter your first name!',
    'forms.lastname': 'Last name',
    'forms.lastname-message': 'Please enter your last name!',

    /* 07.11.Form Components */
    'form-components.custom-inputs': 'Custom Inputs',
    'form-components.checkboxes': 'Checkboxes',
    'form-components.radios': 'Radios',
    'form-components.inline': 'Inline',
    'form-components.react-select': 'React Select',
    'form-components.state-single': 'State Single',
    'form-components.state-multiple': 'State Multiple',
    'form-components.react-autosuggest': 'React Autosuggest',
    'form-components.date-picker': 'Date Picker',
    'form-components.date': 'Date',
    'form-components.date-range': 'Date Range',
    'form-components.date-with-time': 'Date with Time',
    'form-components.embedded': 'Embedded',
    'form-components.dropzone': 'Dropzone',
    'form-components.drop-files-here': 'Drop Files Here',
    'form-components.tags': 'Tags',
    'form-components.switch': 'Switch',
    'form-components.primary': 'Primary',
    'form-components.secondary': 'Secondary',
    'form-components.primary-inverse': 'Primary Inverse',
    'form-components.secondary-inverse': 'Secondary Inverse',
    'form-components.slider': 'Slider',
    'form-components.double-slider': 'Double Slider',
    'form-components.single-slider': 'Single Slider',
    'form-components.rating': 'Rating',
    'form-components.interactive': 'Interactive',
    'form-components.readonly': 'Readonly',
    'form-components.type-a-cake': 'Type a Cake',
    'form-components.start': 'Start',
    'form-components.end': 'End',
    'form-components.tables': 'Tables',
    /* 07.12.Icons */
    'icons.simplelineicons': 'Simple Line Icons',
    'icons.iconsmind': 'Iconsmind Icons',

    /* 07.13.Input Groups */
    'input-groups.basic': 'Basic',
    'input-groups.sizing': 'Sizing',
    'input-groups.small': 'Small',
    'input-groups.default': 'Default',
    'input-groups.large': 'Large',
    'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
    'input-groups.multiple-inputs': 'Multiple Inputs',
    'input-groups.first-and-last-name': 'First and last name',
    'input-groups.multiple-addons': 'Multiple Addons',
    'input-groups.button-addons': 'Button Addons',
    'input-groups.button': 'Button',
    'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
    'input-groups.dropdown': 'Dropdown',
    'input-groups.header': 'Header',
    'input-groups.action': 'Action',
    'input-groups.another-action': 'Another Action',
    'input-groups.custom-select': 'Custom Select',
    'input-groups.options': 'Options',
    'input-groups.choose': 'Choose...',
    'input-groups.custom-file-input': 'Custom File Input',

    /* 07.14.Jumbotron */
    'jumbotron.hello-world': 'Hello, world!',
    'jumbotron.lead':
        'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
    'jumbotron.lead-detail':
        'It uses utility classes for typography and spacing to space content out within the larger container.',
    'jumbotron.learn-more': 'Learn more',

    /* 07.15.Modal */
    'modal.basic': 'Basic',
    'modal.modal-title': 'Modal title',
    'modal.launch-demo-modal': 'Launch Demo Modal',
    'modal.scrolling-long-content': 'Scrolling Long Content',
    'modal.backdrop': 'Backdrop',
    'modal.backdrop-value': 'Backdrop value',
    'modal.right-modal': 'Right Modal',
    'modal.launch-right-modal': 'Launch Right Modal',
    'modal.nested-modal': 'Nested Modal',
    'modal.size': 'Size',
    'modal.launch-large-modal': 'Launch Large Modal',
    'modal.launch-small-modal': 'Launch Small Modal',

    /* 07.16.Navigation */
    'nav.basic': 'Nav Basic',
    'nav.active': 'Active',
    'nav.disabled': 'Disabled',
    'nav.disabled-link': 'Disabled Link',
    'nav.link': 'Link',
    'nav.longer-link': 'Longer nav link',
    'nav.another-link': 'Another Link',
    'nav.right': 'Right',
    'nav.dropdown': 'Dropdown',
    'nav.header': 'Header',
    'nav.action': 'Action',
    'nav.another-action': 'Another Action',
    'nav.horizontal-alignment': 'Nav Horizontal Alignment',
    'nav.vertical-alignment': 'Nav Vertical Alignment',
    'nav.pills': 'Nav Pills',
    'nav.fill-justify': 'Nav Fill and Justify',
    'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
    'nav.pagination-basic': 'Pagination Basic',
    'nav.pagination-sizing': 'Pagination Sizing',
    'nav.large': 'Large',
    'nav.small': 'Small',
    'nav.center': 'Center',
    'nav.pagination-alignment': 'Pagination Alignment',
    'nav.breadcrumb-basic': 'Breadcrumb Basic',

    /* 07.17.Popover & Tooltip */
    'popover-tooltip.popover': 'Popover',
    'popover-tooltip.tooltip': 'Tooltip',

    /* 07.18.Sortable */
    'sortable.columns': 'Sorting Columns',
    'sortable.basic': 'Basic',
    'sortable.handles': 'Handles',

    /* 07.19.Maps */
    'maps.google': 'Google',
    'maps.yandex': 'Yandex',

    /* 07.20.Tables */
    'table.bootstrap-tables': 'Bootstrap Tables',
    'table.bootstrap-basic': 'Basic Table',
    'table.bootstrap-striped': 'Striped Rows',
    'table.bootstrap-bordered': 'Bordered Table',
    'table.bootstrap-borderless': 'Borderless Table',
    'table.bootstrap-hoverable': 'Hoverable Rows',
    'table.bootstrap-responsive': 'Responsive Table',
    'table.react-tables': 'React Tables',
    'table.react-pagination': 'Pagination',
    'table.react-scrollable': 'Scrollable',
    'table.react-advanced': 'Filter, Length and Jump',

    /* Property Info */
    'property-info.about-property': 'เกี่ยวกับอสังหาริมทรัพย์',
    'property-info.about-properties': 'เกี่ยวกับคุณสมบัติ',
    'property-info.facilities-services': 'สิ่งอำนวยความสะดวกและบริการ',
    'property-info.property-facilities': 'สิ่งอำนวยความสะดวกของที่พัก',
    'property-info.room-amenities': 'สิ่งอำนวยความสะดวกในห้องพัก',
    'property-info.property-contact': 'ติดต่อทรัพย์สิน',
    'property-info.property-activities': 'กิจกรรมด้านอสังหาริมทรัพย์',
    'property-info.property-location': 'ที่ตั้งทรัพย์สิน',
    'property-info.about-rooms': 'ห้องพัก',
    'property-info.about-sites': 'เกี่ยวกับไซต์',
    'property-info.special-emergencies': 'กรณีฉุกเฉิน',
    'property-info.gallery': 'แกลเลอรี่',
    'property-info.policies': 'นโยบาย',
    'property-info.nearby': 'ใกล้เคียง',
    'property-info.transport': 'ขนส่ง',
    'property-info.location': 'ที่ตั้ง',
    'property-info.about-rhproperty': 'เกี่ยวกับบ้านพักคนชรา',
    'property-info.related-topics': 'หัวข้อที่เกี่ยวข้อง',
    'property-info.assistant-options': 'เมนูผู้ช่วย',
    'property-info.restaurant-assistant-information': 'ข้อมูลร้านอาหาร',
    'property-info.restaurant-assistant-options': 'ข้อความต้อนรับ',
    'property-info.channel-messages': 'ข้อความช่อง',
    'property-info.icon.gallery': 'ไอคอนแกลลอรี่',
    'property-info.copilot': 'นักบิน',
    'property-info.sprint': 'วิ่ง',
    'property-info.home-information': 'ข้อมูลบ้าน',
    'property-info.loction': 'สถานที่',
    'property-info.rooms-and-images': 'ห้องพักและรูปภาพ',
    'property-info.trainig-data': 'ข้อมูลการฝึกอบรม',
    'property-info.flows': 'กระแส',
    'property-info.add-your-own': 'เพิ่มของคุณเอง',
    'property-info-utility-miscellaneous': 'เบ็ดเตล็ด',
    'property-info-utility-payment': 'การชำระเงิน',
    'property-info-utility-broadband': 'บรอดแบนด์',
    'property-info-utility-emergency': 'ภาวะฉุกเฉิน',
    'property-info-utility-mobile': 'มือถือ',
    'property-info-utility-moving': 'การย้าย',

    /** Rate & Promo */
    'rate-promo.rate-plans': 'แผนอัตรา',
    'rate-promo.rate-plan-addons': "ส่วนเสริม",
    'rate-promo.rate-plan-promos': 'โปรโมชั่น',

    'title.property-information': 'ข้อมูลทรัพย์สิน',

    'property.message': 'ข้อความ',
    'property.example': 'ตัวอย่าง',
    'property.link': 'ลิงค์',
    'property.image-carousel': 'ภาพหมุน',
    'property.Title': 'ชื่อ',
    'property.SubTitle': 'หัวข้อย่อย',

    'property.add-invoke-api': 'เรียกใช้ Api',
    'property.add-message-button': 'เพิ่มข้อความ',
    'property.add-img-button': 'เพิ่มรูปภาพ',
    'property.add-link-button': 'เพิ่มลิงค์',
    'property.add-herocard-button': 'เพิ่มการ์ดฮีโร่',
    'property.add-api-button': 'เพิ่มปุ่ม',

    'menu.about-property': 'เกี่ยวกับอสังหาริมทรัพย์',
    'menu.property-facilities': 'สิ่งอำนวยความสะดวกของที่พัก',
    'menu.room-amenities': 'สิ่งอำนวยความสะดวกในห้องพัก',
    'menu.property-contact': 'ติดต่อทรัพย์สิน',
    'menu.about-rooms': 'ห้องพัก',
    'menu.special-emergencies': 'กรณีฉุกเฉิน',
    'menu.show-filter': 'ตัวกรอง',
    'menu.new': 'ใหม่',

    'dashboards.common-asked': 'คำถามที่พบบ่อย',
    'dashboards.website-visitor-asking': 'สิ่งที่ผู้เยี่ยมชมเว็บไซต์กำลังถามถึง',
    'dashboards.visit-country': 'การเข้าชมเว็บไซต์ตามประเทศ',
    'dashboards.visit-traffic': 'ประเทศของการเข้าชมเว็บไซต์',
    'dashboards.rooms-product': 'ห้องพักและผลิตภัณฑ์',
    'dashboards.popular-room-product': 'ห้องพักและผลิตภัณฑ์ยอดนิยม',

    'dashboards.messenger-stats': 'รายการเมนูยอดนิยม',
    'dashboards.messenger-stats-topic-view': 'สถิติในการดูรายการเมนู',
    'dashboards.messenger-stats-visits': 'มุมมองรายการเมนู',
    'dashboards.opening-menu-items': 'จำนวนผู้เยี่ยมชมเว็บไซต์ที่เปิดรายการเมนู',

    'dashboards.number-totalavatarclick': 'การคลิกรูปประจำตัวทั้งหมด',

    'dashboards.clicks': 'จำนวนคลิก',
    'dashboards.leads': 'โอกาสในการขาย',
    'dashboards.hours': 'ชั่วโมง',
    'dashboards.minutes': 'นาที',

    'dashboards.ai-chatbot': 'เอไอ แชทบอท',
    'dashboards.compendium': 'บทสรุป',
    'dashboards.compendium-digital-usage': 'การใช้บทสรุปดิจิทัล',
    'dashboards.compendium-unique-visits': 'การเข้าชมที่ไม่ซ้ำ',
    'dashboards.compendium-opening-menu-items': 'จำนวนรายการเมนูที่ดู',
    'dashboards.compendium-total-digital-clicks': 'จำนวนคลิกสรุปดิจิทัลทั้งหมด',

    'property.delete': 'ลบ',
    'menu.userroles': 'ผู้ใช้และบทบาท',
    'menu.ratebookings': 'ราคาและการจอง',
    'dashboards.engagement-time': 'เวลาการมีส่วนร่วมของผู้ช่วยดิจิทัล',
    'dashboards.conversations-minutes': 'นาทีรวมและข้ามคืน (19.00 น. ถึง 07.00 น.) นาทีการสนทนา',
    'dashboards.visitor-questions': 'คำถามของผู้เยี่ยมชม',
    'dashboards.recent-queries': 'แบบสอบถามล่าสุด',
    'dashboards.visitor-saying': 'ผู้เยี่ยมชมของคุณพูดอะไรกับ Digital Assistant',
    'dashboards.contacts-prechatform-leavemessage': 'รายชื่อติดต่อที่เก็บไว้จากแบบฟอร์มแชทล่วงหน้าและฝากข้อความ',
    'menu.dashboards': 'ข้อมูลเชิงลึก',
    'menu.ari': 'ห้องว่างและราคา',
    'menu.conversations': 'บทสนทนา',
    'menu.conversations.unified-inbox': 'กล่องจดหมายแบบรวม',
    'menu.conversations.active': 'แชทที่ใช้งานอยู่',
    'menu.conversations.archives': 'หอจดหมายเหตุ',
    'menu.conversations.missed-responses': 'การตอบกลับที่ไม่ได้รับ',
    'menu.conversations.ticket': 'ตั๋ว',
    'menu.conversations.reply-templates': 'ตอบกลับเทมเพลต',
    'menu.bookings': 'การจองและการจอง',
    'menu.tickets': 'ข้อมูลลูกค้าเป้าหมายและตั๋ว',
    'menu.propinfo': 'ศูนย์กลางความรู้',
    'menu.rate-promos': 'อัตราและโปรโมชั่น',
    'menu.finance': 'การเงิน',
    'menu.integration': 'เชื่อมต่อ',
    'menu.admin': 'ผู้ดูแลระบบและความปลอดภัย',
    'menu.favourites': 'รายการโปรด',
    'menu.recommender': 'กระแสการสนทนา',
    'menu.assistant-setup': 'การตั้งค่าผู้ช่วย',
    'menu.admin-insights': 'ข้อมูลเชิงลึกของผู้ดูแลระบบ',
    'menu.super-admin': 'ผู้ดูแลระบบขั้นสูง',
    'menu.groups': 'กลุ่ม',
    'menu.properties': 'คุณสมบัติ',
    'menu.service-provider': 'ผู้ให้บริการ',
    'menu.spaces': 'ช่องว่าง',

    'dashboards.space-booking': 'การจองพื้นที่',
    'dashboards.gift-voucher': 'บัตรกำนัล',
    'dashboards.chatbots': 'แชทบอท',
    'dashboards.form': 'จาก',
    'dashboards.to': 'ถึง',
    'dashboards.active-groups': 'กลุ่มที่ใช้งานอยู่',
    'dashboards.active-properties': 'คุณสมบัติที่ใช้งานอยู่',
    'dashboards.live-properties': 'คุณสมบัติสด',
    'dashboards.properties-going': 'คุณสมบัติที่ใช้งานจริงตามช่วงวันที่',
    'dashboards.start-date': 'วันที่เริ่มต้น',
    'dashboards.end-date': 'วันที่สิ้นสุด',

    'dashboards.website-visits': 'การเข้าชมเว็บไซต์',
    'dashboards.unique-visitors': 'ผู้เยี่ยมชมที่ไม่ซ้ำ',
    'dashboards.last-week': 'อาทิตย์ที่แล้ว',
    'dashboards.this-week': 'ในสัปดาห์นี้',
    'dashboards.this-month': 'เดือนนี้',
    'dashboards.previous-month': 'เดือนที่แล้ว',
    'dashboards.yeartodate': 'ปีถึงวัน',
    'dashboards.lastyear': 'ปีที่แล้ว',
    'dashboards.last-7-days': '7 วันที่ผ่านมา',
    'dashboards.last-30-days': '30 วันที่ผ่านมา',
    'dashboards.last-60-days': '60 วันที่ผ่านมา',
    'dashboards.last-90-days': '90 วันที่ผ่านมา',
    'dashboards.conversion-rates': 'อัตราการแปลง',
    'dashboards.digital-assistant-engagement': 'การมีส่วนร่วมของผู้ช่วยดิจิทัล',
    'dashboards.total-overnight-conversations': 'การสนทนาทั้งหมดและข้ามคืน (19.00 น. ถึง 07.00 น.)',
    'dashboards.percentage-accuracy': 'ทำความเข้าใจกับความถูกต้อง',
    'dashboards.percentage-conversion': 'การเข้าชมเว็บไซต์สู่การแปลงการแชท',
    'dashboards.percentage-avatarclick': 'การเข้าชมเว็บไซต์สู่การคลิก Avatar',
    'dashboards.percentage-negativefeedback': 'ผลตอบรับเชิงลบเป็น %อายุของการคลิกอวาตาร์',
    'dashboards.percentage-amenties': 'แบบสอบถามสิ่งอำนวยความสะดวก',
    'dashboards.percentage-booking': 'สอบถามข้อมูลการจอง',
    'dashboards.percentage-webchats': 'แชทเว็บไซต์',
    'dashboards.percentage-facebookchat': 'แชทเฟสบุ๊ค',
    // 'dashboards.number-webchattime': 'Total Web Chat Time',
    'dashboards.number-webchattime': 'เวลาสนทนาทั้งหมด',
    'dashboards.number-totalconversation': 'บทสนทนาทั้งหมด',
    'dashboards.number-websiteconversation': 'การสนทนาบนเว็บไซต์',
    'dashboards.number-facebookconversation': 'การสนทนาบน Facebook',
    'dashboards.number-estimatedtimesaving': 'ประหยัดเวลาโดยประมาณ',
    'dashboards.number-googlemapsconversation': 'การสนทนาของ Google แผนที่',
    'dashboards.number-whatsappconversation': 'การสนทนา WhatsApp',
    'dashboards.number-instagramconversation': 'บทสนทนาบนอินสตาแกรม',
    'dashboards.number-agentconversation': 'การสนทนาของตัวแทน',
    'dashboards.number-amenityqueries': 'แบบสอบถามสิ่งอำนวยความสะดวก',
    'dashboards.number-bookingenquiries': 'สอบถามการจอง',
    'dashboards.number-groupbookingenquiries': 'สอบถามการจองแบบหมู่คณะ',
    'dashboards.number-eventenquiries': 'สอบถามข้อมูลกิจกรรม',
    'dashboards.number-longstayenquiries': 'สอบถามข้อมูลการเข้าพักระยะยาว',
    'dashboards.number-totaltickets': 'ตั๋ว',
    'dashboards.number-returncustomer': 'ส่งคืนลูกค้า',
    'dashboards.number-redirects': 'การเปลี่ยนเส้นทางเว็บไซต์',
    'dashboards.number-bookingengineleads': 'ผู้นำด้านระบบการจอง',
    'dashboards.number-roomnightsreferred': "ห้องพักคืนอ้างอิง",
    'dashboards.number-revenuereferred': "รายได้ที่อ้างถึง",
    'menu.bookingsmenu': 'การจอง',
    'menu.guests': 'ข้อมูลแขก',
    'menu.whatsnew': "มีอะไรใหม่",

    'menu.formbuilder': 'ตัวสร้างแบบฟอร์ม',
    'forms.forms-title': 'แบบฟอร์ม',

    'menu.virtualfrontdesk': 'แผนกต้อนรับเสมือน',
    'menu.guestservice': 'บริการแขก',
    'virtual-front.common-questions': "คำถามทั่วไป",
    'virtual-front.add-on-upsells': "ส่วนเสริมและการขายต่อยอด",
    'virtual-front.service-order': "คำสั่งบริการ",
    // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
    'virtual-front.guest-service-add-on-upsells': "บทสรุปดิจิทัล",
    'virtual-front.outbound': "ขาออก",
    'virtual-messenger': "Web Widget Menus",

    'missed-response.missed-response-title': "หัวข้อการตอบกลับที่ไม่ได้รับ",
};
